import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="section about">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="section-title">About Prangio Designs</h2>
            <p className="section-subtitle">
              With over a decade of experience in architecture and interior design, we create spaces that tell stories and inspire lives.
            </p>
            <p>
              Our team of passionate designers and architects believes that great design goes beyond aesthetics. 
              We focus on creating functional, sustainable, and beautiful spaces that reflect our clients' personalities 
              and enhance their daily experiences.
            </p>
            <p>
              From residential homes to commercial spaces, we approach each project with fresh eyes and innovative solutions, 
              ensuring that every detail contributes to the overall harmony of the design.
            </p>
            <div className="about-stats">
              <div className="stat">
                <h3>150+</h3>
                <p>Projects Completed</p>
              </div>
              <div className="stat">
                <h3>12+</h3>
                <p>Years Experience</p>
              </div>
              <div className="stat">
                <h3>98%</h3>
                <p>Client Satisfaction</p>
              </div>
            </div>
          </div>
          <div className="about-image">
            <div className="gradient-placeholder">
              <div className="placeholder-content">
                <h4>Our Design Process</h4>
                <p>Consultation → Concept → Design → Implementation</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
